<template>
    <div class="home" v-loading="loading" v-if="web_view == 'web'">
        <swiper id="swiperBox" v-bind:options="swiperOption" ref="mySwiper">
            <swiper-slide class="swiper-slide slide-one">
                <img class="slide-one-left" src="@/assets/img/index/img1_left.png" /> 
                <img class="slide-one-right" src="@/assets/img/index/img1_right.png" /> 
            </swiper-slide>
            <swiper-slide class="swiper-slide slide-two">
                <div class="inside-box">
                    <img src="@/assets/img/index/title1.png" /> 
                </div>
                <img class="slide-one-left2" src="@/assets/img/index/img2_left.png" /> 
                <img class="slide-one-right2" src="@/assets/img/index/img2_right.png" /> 
                <div class="slide-two-left"><p>已经加盟心诚养车门店600+。心诚养车门店定位小而美的中小个体修理厂，此类门店整体规模小，费用低，可盈利空间大；未来规划超过一万家加盟合作门店进入心诚养车平台。</p></div>
                <div class="slide-two-right"><p>心诚养车以“让车主修车不再难、让修理厂经营不再难”为使命。致力于协同中国70万家中小规模修理厂完成服务升级，努力打造汽车配件从工厂直达修理厂的最高效供应链，让中国制造的高品质产品服务于中国汽车后市场！</p></div>
            </swiper-slide>
            <swiper-slide class="swiper-slide slide-three">
                <div class="inside-box">
                    <img src="@/assets/img/index/title2.png" /> 
                </div>
                <el-carousel class="slide-three-img" height="345px" :interval="5000" arrow="always">
                    <el-carousel-item>
                        <img class="slide-three-img" src="@/assets/img/index/img3.png" /> 
                    </el-carousel-item>
                    <el-carousel-item>
                        <img class="slide-three-img" src="@/assets/img/index/lb2.png" /> 
                    </el-carousel-item>
                    <el-carousel-item>
                        <img class="slide-three-img" src="@/assets/img/index/lb3.png" /> 
                    </el-carousel-item>
                    <el-carousel-item>
                        <img class="slide-three-img" src="@/assets/img/index/lb4.png" /> 
                    </el-carousel-item>
                    <el-carousel-item>
                        <img class="slide-three-img" src="@/assets/img/index/lb5.png" /> 
                    </el-carousel-item>
                    <el-carousel-item>
                        <img class="slide-three-img" src="@/assets/img/index/lb6.png" /> 
                    </el-carousel-item>
                    <el-carousel-item>
                        <img class="slide-three-img" src="@/assets/img/index/lb7.png" /> 
                    </el-carousel-item>
                </el-carousel> 
                <a class="lookMore" @click="toPath('product')">查看更多</a>              
            </swiper-slide>
            <swiper-slide class="swiper-slide slide-four">
                <div class="inside-box">
                    <img src="@/assets/img/index/title3.png" /> 
                </div>
                <div class="slide-four-box">
                    <img class="slide-four-img" src="@/assets/img/index/img4_1.png" />
                    <img class="slide-four-img" src="@/assets/img/index/img4_2.png" />
                    <img class="slide-four-img" src="@/assets/img/index/img4_3.png" />
                    <img class="slide-four-img" src="@/assets/img/index/img4_4.png" />
                </div>
                <a class="lookMore" @click="toPath('productCar')">查看更多</a>  
            </swiper-slide>
            <swiper-slide class="swiper-slide slide-five">
                <div class="inside-box">
                    <img src="@/assets/img/index/title4.png" /> 
                </div>
            <div class="submit-box">
                <div class="submit-box-left">
                    <div class="submit-box-title">
                        <img src="@/assets/img/case/sanjiao.png" />
                        <span>联系我们 / Content us</span>  
                    </div>
                    <div class="submit-box-info">
                        <span class="label">公司地址：</span><span class="value">安徽省芜湖市繁昌区繁阳大道繁昌数字经济产业园</span>                              
                    </div>
                    <div class="submit-box-info">
                        <span class="label">华东运营中心：</span><span class="value">安徽省芜湖市弋江区中山南路717号科技产业园2栋3楼</span>
                    </div>
                    <div class="submit-box-info">
                        <span class="label">服务热线：</span><span class="value">400 996 7650</span>
                    </div>
                    <div class="submit-box-info">
                        <span class="label">网址：</span><span class="value">https://www.xinchengzxw.com/</span>
                    </div>   
                    <div id="container" style="width:100%;height:287px;margin:auto"></div>                                 
                    <!-- <img class="map-img" src="@/assets/img/contactUs/nav2.png" /> -->
                </div>
                <img class="jt" src="@/assets/img/index/jt.png" /> 
                <div class="submit-box-right">
                    <div class="submit-box-title">
                        <img src="@/assets/img/case/sanjiao.png" />
                        <span>申请加盟 / join in</span>  
                    </div>
                    
                    <input class="custom-input2 w-460" placeholder="姓名" v-model="form.name"/>
                    <input class="custom-input2 w-460" placeholder="电话" v-model="form.mobile"/>
                    <!-- <input class="custom-input2 w-320" placeholder="请输入验证码" v-model="form.code"/>
                    <a class="yzm" v-if="isSend == '1'" @click="sendCode()">发送验证码</a>
                    <a class="yzm2" v-else>{{time}}秒后重新发送</a> -->
                    <!-- <input class="custom-input2 w-460" placeholder="地址" v-model="form.mobile"/> -->
                    <!-- <a class="yzm" @click="sendCode()">发送验证码</a> -->
                    <textarea class="custom-text w-460" placeholder="需求" v-model="form.content"/>
                    <a class="submit-btn2" @click="submit()">提交留言</a>
                </div>
            </div>
                <!-- <div class="contact-box">
                    <div class="contact-box-left">
                        <img class="contact-box-left-img" src="@/assets/img/index/code.jpg" />
                        <p class="contact-box-left-title">心诚养车</p>
                        <div class="contact-box-left-info">
                            <p class="contact-box-left-info-title">安徽心诚科技信息有限公司</p>
                            <div class="split-line"></div>
                            <div class="contact-box-left-info-long">
                                <span class="label">公司地址：</span><span class="value">安徽省芜湖市繁昌区繁阳大道繁昌数字经济产业园</span>                              
                            </div>
                            <div class="contact-box-left-info-short">
                                <span class="label">网址：</span><span class="value">https://www.xinchengzxw.com/</span>
                            </div>
                            <div class="contact-box-left-info-long">
                                <span class="label">华东运营中心：</span><span class="value">安徽省芜湖市弋江区中山南路717号科技产业园2栋3楼</span>
                            </div>
                            <div class="contact-box-left-info-short">
                                <span class="label">服务热线：</span><span class="value">400 996 7650</span>
                            </div>
                        </div>
                    </div>
                    <div class="contact-box-right">
                        <input class="custom-input w-200" placeholder="姓名" v-model="form.name"/>
                        <input class="custom-input w-200" placeholder="电话" v-model="form.mobile"/>
                        <textarea class="custom-input w-500" placeholder="内容" v-model="form.content"/>
                        <a class="submit-btn" @click="submit()">提交留言</a>
                    </div>
                </div> -->
            </swiper-slide>
        </swiper>
    </div>
    <div class="home-h5" v-loading="loading" v-else>
        <swiper id="swiperBox2" v-bind:options="swiperOption2" ref="mySwiper">
            <swiper-slide class="swiper-slide slide-one-h5">
            </swiper-slide>
            <swiper-slide class="swiper-slide slide-two-h5">
                <div class="inside-box-h5">
                    <img src="@/assets/img/index/title1.png" /> 
                </div>
                <div class="slide-two-left-h5"><p>已经加盟心诚养车门店600+。心诚养车门店定位小而美的中小个体修理厂，此类门店整体规模小，费用低，可盈利空间大；未来规划超过一万家加盟合作门店进入心诚养车平台。</p></div>
                <div class="slide-two-right-h5"><p>心诚养车以“让车主修车不再难、让修理厂经营不再难”为使命。致力于协同中国70万家中小规模修理厂完成服务升级，努力打造汽车配件从工厂直达修理厂的最高效供应链，让中国制造的高品质产品服务于中国汽车后市场！</p></div>
            </swiper-slide>
            <swiper-slide class="swiper-slide slide-three-h5">
                <div class="inside-box-h5">
                    <img src="@/assets/img/index/title2.png" /> 
                </div>
                <el-carousel class="slide-three-img-h5" height="400px" :interval="5000" arrow="always">
                    <el-carousel-item>
                        <img class="slide-three-img-h5" src="@/assets/img/index/lb2_h5.png" /> 
                    </el-carousel-item>
                    <el-carousel-item>
                        <img class="slide-three-img-h5" src="@/assets/img/index/lb3_h5.png" /> 
                    </el-carousel-item>
                    <el-carousel-item>
                        <img class="slide-three-img-h5" src="@/assets/img/index/lb4_h5.png" /> 
                    </el-carousel-item>
                    <el-carousel-item>
                        <img class="slide-three-img-h5" src="@/assets/img/index/lb5_h5.png" /> 
                    </el-carousel-item>
                    <el-carousel-item>
                        <img class="slide-three-img-h5" src="@/assets/img/index/lb6_h5.png" /> 
                    </el-carousel-item>
                    <el-carousel-item>
                        <img class="slide-three-img-h5" src="@/assets/img/index/lb7_h5.png" /> 
                    </el-carousel-item>
                    <el-carousel-item>
                        <img class="slide-three-img-h5" src="@/assets/img/index/lb8_h5.png" /> 
                    </el-carousel-item>
                </el-carousel> 
                <a class="lookMore-h5" @click="toPath('product')">查看更多</a>              
            </swiper-slide>
            <swiper-slide class="swiper-slide slide-four-h5">
                <div class="inside-box-h5">
                    <img src="@/assets/img/index/title3.png" /> 
                </div>
                <a class="lookMore-h5" @click="toPath('productCar')">查看更多</a>  
            </swiper-slide>
            <swiper-slide class="swiper-slide slide-five-h5">
                <div class="inside-box-h5">
                    <img src="@/assets/img/index/title4.png" /> 
                </div>
                <div class="home-page-five">
                    <div class="contact-box-h5">
                        <!-- <div class="contact-box-left">
                            
                            <div class="contact-box-left-info">
                                <div class="contact-box-left-info-long">
                                    <span class="label">公司地址：</span><span class="value">安徽省芜湖市繁昌区繁阳大道繁昌数字经济产业园</span>                              
                                </div>
                                <div class="contact-box-left-info-long">
                                    <span class="label">运营中心：</span><span class="value">安徽省芜湖市弋江区中山南路717号科技产业园2栋3楼</span>
                                </div>
                                <div class="contact-box-left-info-short">
                                    <span class="label">网址：</span><span class="value">https://www.xinchengzxw.com/</span>
                                </div>                        
                                <div class="contact-box-left-info-short">
                                    <span class="label">服务热线：</span><span class="value">400 996 7650</span>
                                </div>
                            </div>
                            <div class="contact-box-left-code">
                                <img class="contact-box-left-img" src="@/assets/img/index/code.jpg" />
                                <p class="contact-box-left-title">心诚养车</p>
                            </div>
                        </div> -->
                        <div class="contact-box-right">
                            <input class="custom-input w-200" placeholder="姓名" v-model="form.name"/>
                            <input class="custom-input w-200" placeholder="电话" v-model="form.mobile"/>
                            <textarea class="custom-input w-500" placeholder="内容" v-model="form.content"/>
                            <a class="submit-btn" @click="submit()">提交留言</a>
                        </div>
                    </div>
                </div>
                <!-- <div class="inside-box">
                    <img src="@/assets/img/index/title4.png" /> 
                </div>
                <div class="submit-box">
                    <div class="submit-box-left">
                        <div class="submit-box-title">
                            <img src="@/assets/img/case/sanjiao.png" />
                            <span>联系我们 / Content us</span>  
                        </div>
                        <div class="submit-box-info">
                            <span class="label">公司地址：</span><span class="value">安徽省芜湖市繁昌区繁阳大道繁昌数字经济产业园</span>                              
                        </div>
                        <div class="submit-box-info">
                            <span class="label">华东运营中心：</span><span class="value">安徽省芜湖市弋江区中山南路717号科技产业园2栋3楼</span>
                        </div>
                        <div class="submit-box-info">
                            <span class="label">服务热线：</span><span class="value">400 996 7650</span>
                        </div>
                        <div class="submit-box-info">
                            <span class="label">网址：</span><span class="value">https://www.xinchengzxw.com/</span>
                        </div>   
                        <div id="container" style="width:100%;height:287px;margin:auto"></div>
                    </div>
                    <div class="submit-box-right">
                        <div class="submit-box-title">
                            <img src="@/assets/img/case/sanjiao.png" />
                            <span>申请加盟 / join in</span>  
                        </div>
                        <input class="custom-input2 w-460" placeholder="姓名" v-model="form.name"/>
                        <input class="custom-input2 w-460" placeholder="电话" v-model="form.mobile"/>
                        <textarea class="custom-text w-460" placeholder="需求" v-model="form.content"/>
                        <a class="submit-btn2" @click="submit()">提交留言</a>
                    </div>
                </div> -->
            </swiper-slide>
        </swiper>
    </div>
    <!-- <div class="home-h5" v-loading="loading" v-else>
        <div class="home-page-one">
            <img class="home-img" src="@/assets/img/index/home_top.png" />
        </div>
        <div class="home-page-two">
            <img class="home-img" src="@/assets/img/index/home_do.png" />
            <div class="home-page-two-text">
                <img src="@/assets/img/index/title1.png" /> 
                <p>已经加盟心诚养车门店600+。心诚养车门店定位小而美的中小个体修理厂，此类门店整体规模小，费用低，可盈利空间大；未来规划超过一万家加盟合作门店进入心诚养车平台。</p>
                <p>心诚养车以“让车主修车不再难、让修理厂经营不再难”为使命。致力于协同中国70万家中小规模修理厂完成服务升级，努力打造汽车配件从工厂直达修理厂的最高效供应链，让中国制造的高品质产品服务于中国汽车后市场！</p>
            </div>      
        </div>
        <div class="home-page-three">
            <div class="inside-box-h5">
                <img src="@/assets/img/index/title2.png" /> 
            </div>
            <el-carousel class="slide-three-img-h5" height="160px" :interval="5000" arrow="always">
                <el-carousel-item>
                    <img class="slide-three-img-h5" src="@/assets/img/index/img3.png" />  
                </el-carousel-item>
                <el-carousel-item>
                    <img class="slide-three-img-h5" src="@/assets/img/index/lb2.png" /> 
                </el-carousel-item>
                <el-carousel-item>
                    <img class="slide-three-img-h5" src="@/assets/img/index/lb3.png" /> 
                </el-carousel-item>
                <el-carousel-item>
                    <img class="slide-three-img-h5" src="@/assets/img/index/lb4.png" /> 
                </el-carousel-item>
                <el-carousel-item>
                    <img class="slide-three-img-h5" src="@/assets/img/index/lb5.png" /> 
                </el-carousel-item>
                <el-carousel-item>
                    <img class="slide-three-img-h5" src="@/assets/img/index/lb6.png" /> 
                </el-carousel-item>
                <el-carousel-item>
                    <img class="slide-three-img-h5" src="@/assets/img/index/lb7.png" /> 
                </el-carousel-item>
            </el-carousel> 
            <a class="lookMore-h5" @click="toPath('product')">查看更多</a>        
        </div>
        <div class="home-page-four">
            <div class="inside-box-h5">
                <img src="@/assets/img/index/title3.png" /> 
            </div>
            <div class="home-page-four-box">
                <img class="home-page-four-box-img" src="@/assets/img/index/img4_1.png" />
                <img class="home-page-four-box-img" src="@/assets/img/index/img4_2.png" />
                <img class="home-page-four-box-img" src="@/assets/img/index/img4_3.png" />
                <img class="home-page-four-box-img" src="@/assets/img/index/img4_4.png" />
            </div>
            <a class="lookMore-h5" @click="toPath('productCar')">查看更多</a>  
        </div>
        <div class="home-page-five">
            <div class="inside-box-h5">
                <img src="@/assets/img/index/title4.png" /> 
            </div>
            <div class="contact-box-h5">
                <div class="contact-box-left">
                    
                    <div class="contact-box-left-info">
                        <div class="contact-box-left-info-long">
                            <span class="label">公司地址：</span><span class="value">安徽省芜湖市繁昌区繁阳大道繁昌数字经济产业园</span>                              
                        </div>
                        <div class="contact-box-left-info-long">
                            <span class="label">运营中心：</span><span class="value">安徽省芜湖市弋江区中山南路717号科技产业园2栋3楼</span>
                        </div>
                        <div class="contact-box-left-info-short">
                            <span class="label">网址：</span><span class="value">https://www.xinchengzxw.com/</span>
                        </div>                        
                        <div class="contact-box-left-info-short">
                            <span class="label">服务热线：</span><span class="value">400 996 7650</span>
                        </div>
                    </div>
                    <div class="contact-box-left-code">
                        <img class="contact-box-left-img" src="@/assets/img/index/code.jpg" />
                        <p class="contact-box-left-title">心诚养车</p>
                    </div>
                </div>
                <div class="contact-box-right">
                    <input class="custom-input w-200" style="margin-right:2%" placeholder="姓名" v-model="form.name"/>
                    <input class="custom-input w-200" placeholder="电话" v-model="form.mobile"/>
                    <textarea class="custom-input w-500" placeholder="内容" v-model="form.content"/>
                    <a class="submit-btn" @click="submit()">提交留言</a>
                </div>
            </div>
        </div>
    </div> -->
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
    name: "HelloWorld",
    components: {
        swiper,
        swiperSlide,
    },
    data() {
        return {
            web_view:"", // 视图窗口模式 900px以下是手机，以上是PC
            timer:null,
            isSend:"1",
            time:60,
            form:{
                name:"",
                mobile:"",
                content:"",
                code:"",
            },
            mobile:"",
            loading: false,
            caseList: [],
            newsList: [],
            swiperOption: {
                notNextTick: true, // notNextTick是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
                direction: "vertical", // 水平方向移动
                grabCursor: true, // 鼠标覆盖Swiper时指针会变成手掌形状，拖动时指针会变成抓手形状
                setWrapperSize: true, // Swiper使用flexbox布局(display: flex)，开启这个设定会在Wrapper上添加等于slides相加的宽或高，在对flexbox布局的支持不是很好的浏览器中可能需要用到。
                autoHeight: true, // 自动高度。设置为true时，wrapper和container会随着当前slide的高度而发生变化
                slidesPerView: 1, // 设置slider容器能够同时显示的slides数量(carousel模式)。可以设置为数字（可为小数，小数不可loop），或者 'auto'则自动根据slides的宽度来设定数量。loop模式下如果设置为'auto'还需要设置另外一个参数loopedSlides。
                mousewheel: true, // 开启鼠标滚轮控制Swiper切换。可设置鼠标选项，默认值false
                mousewheelControl: true, // 同上
                height: window.innerHeight - 80, // 高度设置，占满设备高度
                resistanceRatio: 0, // 抵抗率。边缘抵抗力的大小比例。值越小抵抗越大越难将slide拖离边缘，0时完全无法拖离。本业务需要
                observeParents: true, // 将observe应用于Swiper的父元素。当Swiper的父元素变化时，例如window.resize，Swiper更新

                // 如果自行设计了插件，那么插件的一些配置相关参数，也应该出现在这个对象中，如下debugger
                // debugger: true,

                // swiper的各种回调函数也可以出现在这个对象中，和swiper官方一样
                on: {

                },
            },
            swiperOption2: {
                notNextTick: true, // notNextTick是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
                direction: "vertical", // 水平方向移动
                grabCursor: true, // 鼠标覆盖Swiper时指针会变成手掌形状，拖动时指针会变成抓手形状
                setWrapperSize: true, // Swiper使用flexbox布局(display: flex)，开启这个设定会在Wrapper上添加等于slides相加的宽或高，在对flexbox布局的支持不是很好的浏览器中可能需要用到。
                autoHeight: true, // 自动高度。设置为true时，wrapper和container会随着当前slide的高度而发生变化
                slidesPerView: 1, // 设置slider容器能够同时显示的slides数量(carousel模式)。可以设置为数字（可为小数，小数不可loop），或者 'auto'则自动根据slides的宽度来设定数量。loop模式下如果设置为'auto'还需要设置另外一个参数loopedSlides。
                mousewheel: true, // 开启鼠标滚轮控制Swiper切换。可设置鼠标选项，默认值false
                mousewheelControl: true, // 同上
                height: window.innerHeight - 48, // 高度设置，占满设备高度
                resistanceRatio: 0, // 抵抗率。边缘抵抗力的大小比例。值越小抵抗越大越难将slide拖离边缘，0时完全无法拖离。本业务需要
                observeParents: true, // 将observe应用于Swiper的父元素。当Swiper的父元素变化时，例如window.resize，Swiper更新

                // 如果自行设计了插件，那么插件的一些配置相关参数，也应该出现在这个对象中，如下debugger
                // debugger: true,

                // swiper的各种回调函数也可以出现在这个对象中，和swiper官方一样
                on: {

                },
            },
        };
    },
    created() {},
    // 如果你需要得到当前的swiper对象来做一些事情，你可以像下面这样定义一个方法属性来获取当前的swiper对象，同时notNextTick必须为true
    computed: {
        swiper() {
            return this.$refs.mySwiper.swiper;
        },
    },
    mounted() {
        let that = this
        if(parseFloat(document.body.clientWidth) < 900){
            this.web_view = 'h5'
        }else{
            this.web_view = 'web'
        }
        window.addEventListener('resize', function() {// 变化后需要做的事
            if(parseFloat(document.body.clientWidth) < 900){
                this.web_view = 'h5'
            }else{
                this.web_view = 'web'
            }
        })
        setTimeout(function(){
            that.initMap()
        },600)
    },
    methods: {
        initMap(){
            console.log("加载地图")
            // 创建地图实例
            var map = new AMap.Map("container", {
                zoom: 16,
                center: [118.36417,31.27174],
                resizeEnable: true
            });
            console.log("加载地图",map)
            // 以 icon URL 的形式创建一个途经点
            var viaMarker = new AMap.Marker({
                position: new AMap.LngLat(118.36417,31.27174),
                // 将一张图片的地址设置为 icon
                icon: '//a.amap.com/jsapi_demos/static/demo-center/icons/dir-via-marker.png',
                // 设置了 icon 以后，设置 icon 的偏移量，以 icon 的 [center bottom] 为原点
                offset: new AMap.Pixel(-13, -30)
            });

            // 创建一个 Icon
            var startIcon = new AMap.Icon({
                // 图标尺寸
                size: new AMap.Size(25, 34),
                // 图标的取图地址
                image: '//a.amap.com/jsapi_demos/static/demo-center/icons/dir-marker.png',
                // 图标所用图片大小
                imageSize: new AMap.Size(135, 40),
                // 图标取图偏移量
                imageOffset: new AMap.Pixel(-9, -3)
            });

            // 将 icon 传入 marker
            var startMarker = new AMap.Marker({
                position: new AMap.LngLat(118.36417,31.27174),
                icon: startIcon,
                offset: new AMap.Pixel(-13, -30)
            });

            // 创建一个 icon
            var endIcon = new AMap.Icon({
                size: new AMap.Size(25, 34),
                image: '//a.amap.com/jsapi_demos/static/demo-center/icons/dir-marker.png',
                imageSize: new AMap.Size(135, 40),
                imageOffset: new AMap.Pixel(-95, -3)
            });

            // 将 icon 传入 marker
            var endMarker = new AMap.Marker({
                position: new AMap.LngLat(118.36417,31.27174),
                icon: endIcon,
                offset: new AMap.Pixel(-13, -30)
            });

            // 将 markers 添加到地图
            map.add([endMarker]);
        },
        toPath(e){
            this.$router.push({ name: e });
        },
        sendCode(){
            let that = this
            if(this.form.mobile == ""){
                this.$message({
                    message: "请输入手机号码",
                    type: "warning"
                }); 
                return
            }
            this.$http
            .post("franchise_applications/send_code", {
                mobile:this.form.mobile
            })
            .then(response => {
                if(response.data.code == 200){
                    this.$message({
                        message: "发送成功！",
                        type: "success"
                    });
                    this.isSend = '0'
                    this.timer = setInterval(function() {
                        // 判断剩余秒数
                        if (that.time == 0) {
                        // 清除定时器和复原按钮
                            clearInterval(that.timer);
                            that.isSend = '1'
                            that.time = 60
                        } else {
                            that.time--;
                        }
                    }, 1000);
                }else{
                    this.$message({
                        message: response.data.msg,
                        type: "warning"
                    });     
                }
                
            })
            .catch(e => {
                this.$message({
                message: "网络或程序异常！" + e,
                type: "error"
                });
            });
        },
        submit(){
            this.$http
            .post("franchise_applications/store", this.form)
            .then(response => {
                if(response.data.code == 200){
                    this.$message({
                        message: "提交成功！",
                        type: "success"
                    });
                }else{
                    this.$message({
                        message: response.data.msg,
                        type: "warning"
                    });     
                }             
            })
            .catch(e => {
                this.$message({
                message: "网络或程序异常！" + e,
                type: "error"
                });
            });
        },
    }

};
</script>

<style lang="scss" scoped>
/* .el-header {
  position: absolute;
} */
.swiper-slide {
    font-size: 24px;
    // text-align: center;
    // line-height: 100px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-content: center;

    .page {
        text-align: center;
        height: 100px;
        overflow: hidden;
        h3,
        p {
            font-size: 40px;
            font-weight: 400;
            color: #fff;
        }
    }

    .slogan {
        text-align: center;
        font-size: 50px;
        color: #fff;
        padding: 30px 0;
    }
}
//经典案例
.case-item {
    width: 1100px;
    height: 500px;
    overflow: hidden;
    margin: 0 auto;
    margin-top: 30px;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    li {
        width: 330px;
        height: 250px;
        list-style: none;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
        background-origin: content-box;
        margin: 5px;
        position: relative;
        overflow: hidden;

        &:hover {
            .case-item-hover {
                opacity: 1;
                transition: all 0.4s ease-in-out;
            }
        }
    }
}
//经典案例hover
.case-item-hover {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
    overflow: hidden;
    background-color: rgba(225, 56, 52, 0.7);

    .hover-title {
        height: 50px;
        color: #fff;
        font-size: 18px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-weight: 400;
        margin-top: 20px;
    }
    .bottom {
        border-bottom: 1px solid #fff;
        width: 60px;
        margin: 0 auto;
    }
    .more {
        width: 90px;
        padding: 5px 5px;
        margin: 0 auto;
        margin-top: 100px;
        border: 2px solid #fff;
        span {
            color: #fff;
            font-size: 20px;
        }
    }
}
// .swiper-slide:nth-child(2n) {
//   background: skyblue;
// }
// .swiper-slide:nth-child(2n-1) {
//   background: seashell;
// }
.slide-one {
    background: url(../assets/img/index/home_top.png) no-repeat center;
    background-size: cover;
}
.slide-one-h5 {
    background: url(../assets/img/index/home_top_h5.png) no-repeat center;
    background-size: cover;
}
.slide-two {
    background: url(../assets/img/index/home_do.png) no-repeat center;
    background-size: cover;
}
.slide-two-h5 {
    background: url(../assets/img/index/home_do_h5.png) no-repeat center;
    background-size: cover;
}
.slide-three {
    background: url(../assets/img/index/home_anli.png) no-repeat center;
    background-size: cover;
}
.slide-three-h5 {
    background: url(../assets/img/index/home_anli_h5.png) no-repeat center;
    background-size: cover;
}
.slide-four {
    background: url(../assets/img/index/img4.png) no-repeat center;
    background-size: cover;
}
.slide-four-h5 {
    background: url(../assets/img/index/img4_h5.png) no-repeat center;
    background-size: cover;
}
.slide-five {
    background: url(../assets/img/index/img5.png) no-repeat center;
    background-size: cover;
}
.slide-five-h5 {
    background: url(../assets/img/index/img5_h5.png) no-repeat center;
    background-size: cover;
}
//最新资讯
.news-content {
    width: 1240px;
    margin: 0 auto;
    margin-top: 40px;
    display: flex;
    justify-content: center;

    &-item {
        width: 400px;
        display: flex;
        flex-direction: column;

        .item-img {
            width: 360px;
            height: 230px;
            background-repeat: no-repeat;
            background-size: cover;
            background-position: center;
            background-origin: content-box;
            margin: 0 auto;
        }
        .el-divider {
            background-color: #fff;
            height: 3px;
            .el-divider__text {
                width: 20px;
                height: 20px;
                border-radius: 50%;
                padding: 0px;
                color: #fff;
            }
        }
        .item-content {
            width: 360px;
            height: 230px;
            margin: 0 auto;
            //border: 1px solid paleturquoise;
            h3 {
                font-size: 22px;
                height: 30px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
            p {
                font-size: 15px;
                height: 80px;
                overflow: hidden;
                margin: 10px 0;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 4;
                -webkit-box-orient: vertical;
                white-space: normal !important;
                word-wrap: break-word;
            }
            span {
                display: block;
                font-size: 14px;
                text-align: end;
            }
            h3,
            p,
            span {
                color: #fff;
            }
        }
    }
}
.order {
    order: -1;
}
.order-img {
    order: 1;
}
.slide-two-left {
    position: absolute;
    left: 50%;
    width: 400px;
    margin-left: 50px;
    background: #ffffffab;
    padding: 20px;
    box-sizing: border-box;
    font-size: 20px;
    text-align: justify;
    text-indent: 42px;
    line-height: 36px;
    letter-spacing: 2px;
    height: 300px;
    bottom: 100px;
}
.slide-two-left p {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    font-size: 20px;
    text-align: justify;
    text-indent: 42px;
    line-height: 36px;
    letter-spacing: 2px; 
    bottom: 100px;
    color: #111;
}
.slide-two-right {
    position: absolute;
    right: 50%;
    width: 400px;
    margin-right: 50px;
    background: #ffffffab;
    padding: 20px;
    box-sizing: border-box;
    font-size: 20px;
    text-align: justify;
    text-indent: 42px;
    line-height: 36px;
    letter-spacing: 2px;
    height: 300px;
    bottom: 100px;
}
.slide-two-right p {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    font-size: 20px;
    text-align: justify;
    text-indent: 42px;
    line-height: 36px;
    letter-spacing: 2px; 
    bottom: 100px;
    color: #111;
}

.slide-two-left-h5 {
    position: absolute;
    width: 90%;
    background: #ffffffab;
    padding: 20px;
    box-sizing: border-box;
    font-size: 14px;
    text-align: justify;
    text-indent: 30px;
    line-height: 24px;
    margin-left: 5%;
    top: 160px;
}
.slide-two-left-h5 p {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    font-size: 14px;
    text-align: justify;
    text-indent: 30px;
    line-height: 24px;
    color: #111;
}
.slide-two-right-h5 {
    position: absolute;
    width: 90%;
    background: #ffffffab;
    padding: 20px;
    box-sizing: border-box;
    font-size: 14px;
    text-align: justify;
    text-indent: 30px;
    line-height: 24px;
    margin-left: 5%;
    top: 320px;
}
.slide-two-right-h5 p {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    font-size: 14px;
    text-align: justify;
    text-indent: 30px;
    line-height: 24px;
    color: #111;
}


.slide-three-img {
    width: 800px;
    height: auto;
    margin: auto;
}
.slide-three-img-h5 {
    width: 320px;
    height: auto;
    margin: auto;
}
.slide-four-box {
    width: 980px;
    height: 600px;
    margin: auto;
    margin-top: 200px;
}
.slide-four-img {
    width: 446px;
    height: 218px;
    float: left;
    margin: 22px;
    box-sizing: border-box;
}
.contact-box {
    width: 1200px;
    height: 520px;
    margin: auto;
    padding: 40px 0;
    box-sizing: border-box;
    .contact-box-left {
        width: 600px;
        height: 100%;
        float: left;
        box-sizing: border-box;
        .contact-box-left-img {
            width: 160px;
            height: 160px;
            margin-left: 220px;
        }
        .contact-box-left-title {
            font-size: 14px;
            color: #fff;
            width: 160px;
            text-align: center;
            margin-left: 220px;
            margin-bottom: 80px;
        }
        .contact-box-left-info {
            font-size: 12px;
            color: #fff;
            .contact-box-left-info-title {

            }
            .split-line {
                height: 2px;
                width: 580px;
                background: #fff;
                margin: 10px 0;
            }
            .contact-box-left-info-long {
                width: 380px;
                height: 24px;
                line-height: 24px;
                float: left;
                .label {
                    width: 90px;
                    display: inline-block;
                }
            }
            .contact-box-left-info-short {
                width: 220px;
                height: 24px;
                line-height: 24px;
                float: left;
                .label {
                    width: 72px;
                    display: inline-block;
                }
            }

        }
    }
    .contact-box-right {
        width: 600px;
        height: 100%;
        float: left;
        .w-200 {
            width: 280px;
        }
        .w-500 {
            width: 570px;
            height: 200px !important;
        }
        .yzm {
            height: 50px;
            line-height: 50px;
            display: inline-block;
            box-sizing: border-box;
            margin: 1px;
            background: #fff;
            text-align: center;
            font-size: 16px;
            width: 120px;
            color: #f56c6c;
        }
        .yzm2 {
            height: 50px;
            line-height: 50px;
            display: inline-block;
            box-sizing: border-box;
            margin: 1px;
            background: #fff;
            text-align: center;
            font-size: 14px;
            width: 120px;
            color: #f56c6c;
        }
        .custom-input {
            background: #fff;
            border: none;
            padding: 4px 8px;
            box-sizing: border-box;
            color: #333;
            height: 50px;
            line-height: 50px;
            font-size: 16px;
            margin-right: 20px;
            margin-bottom: 20px;
        }
        .submit-btn {
            height: 50px;
            line-height: 50px;
            display: inline-block;
            box-sizing: border-box;
            margin: 1px;
            background: #f00f0f;
            text-align: center;
            font-size: 16px;
            width: 120px;
            color: #fff;
        }
    }
}
.inside-box {
    width: 300px;
    height: 100px;
    margin: auto;
    text-align: center;
    position: absolute;
    top: 100px;
    left: 50%;
    margin-left: -150px;
}
.lookMore {
    width: 150px;
    background: red;
    color: #fff;
    font-size: 16px;
    text-align: center;
    height: 32px;
    line-height: 32px;
    border-radius: 4px;
    cursor: pointer;
    position: absolute;
    bottom: 100px;
    left: 50%;
    margin-left: -75px;
}
.lookMore-h5 {
    width: 120px;
    background: red;
    color: #fff;
    font-size: 14px;
    text-align: center;
    height: 32px;
    line-height: 32px;
    border-radius: 4px;
    cursor: pointer;
    position: absolute;
    bottom: 20px;
    left: 50%;
    margin-left: -60px;
}
.home-h5 {
    .home-img {
        width: 100vw;
    }
    .home-page-one {
        position: relative;
    }
    .home-page-two {
        position: relative;
        .home-page-two-text {
            text-align: center;
            width: 100%;
            height: 100%;
            padding: 10px;
            box-sizing: border-box;
            background: #ffffffab;
            position: absolute;
            z-index: 2;
            top: 0;
            img {
                width: 100px;
                margin: 10px 0;
            }
            p {
                font-size: 12px;
                line-height: 18px;
                text-indent: 25px;
                text-align: justify;
            }
        }
    }
    .home-page-three {
        position: relative;
        width: 100%;
        height: 310px;
        background: url(../assets/img/index/home_anli.png) no-repeat center;
        background-size: cover;
        padding: 0 20px;
        box-sizing: border-box;

        .slide-three-img-h5 {
            width: 100%;
            height: auto;
            margin: auto;
        }
    }
    .home-page-four {
        width: 100%;
        position: relative;
        background: url(../assets/img/index/img4.png) no-repeat center;
        background-size: cover;
        .inside-box-h5 {
            width: 100%;
            height: 80px;
            text-align: center;
            padding-top: 20px;
            box-sizing: border-box;
            img {
                width: 100px;
            }
        }
        .home-page-four-box {
            padding: 10px;
            box-sizing: border-box;
            padding-bottom: 60px;
            img {
                width: 100%;
                margin-bottom: 10px;
            }
        }
    }
    .home-page-five {
        width: 100%;
        position: relative;
        //background: url(../assets/img/index/img5.png) no-repeat center;
        background-size: cover;
        height: 100%;
        margin-top: 160px;
        .inside-box-h5 {
            width: 100%;
            height: 80px;
            text-align: center;
            padding-top: 20px;
            box-sizing: border-box;
            img {
                width: 100px;
            }
        }
    }
   
}
.submit-box {
    width: 960px;
    height: 600px;
    margin: auto;
    margin-top: 210px;
    .submit-box-left {
        float: left;
        width: 470px;
        margin-right: 10px;
        .submit-box-info {
            color: #fff;
            text-align: left;
            font-size: 14px;
            margin-bottom: 15px;
        }
        .map-img {
            width: 470px;
            margin-top: 36px;
        }
    }
    .submit-box-right {
        float: left;
        width: 470px;
        margin-left: 10px;
        position: relative;
    }
}
.custom-input2 {
    background: #ffffffb3;
    border: 1px solid #ffffffb3;
    border-radius: 4px;
    padding: 4px 8px;
    box-sizing: border-box;
    color: #333;
    height: 50px;
    line-height: 50px;
    font-size: 16px;
    margin-right: 20px;
    margin-bottom: 12px;
}
.custom-text {
    background: #ffffffb3;
    border: 1px solid #ffffffb3;
    border-radius: 4px;
    padding: 4px 8px;
    box-sizing: border-box;
    color: #333;
    height: 224px;
    line-height: 50px;
    font-size: 16px;
    margin-right: 20px;
    margin-bottom: 20px;
}
.submit-btn2 {
    height: 50px;
    line-height: 50px;
    display: inline-block;
    box-sizing: border-box;
    background: #ee1919;
    text-align: center;
    font-size: 16px;
    width: 460px;
    color: #fff;
    position: relative;
    left: -4px;
}
.submit-box-title {
    color: #fff;
    height: 60px;
    img {
        float: left;
        height: 24px;
        width: 16px;
        margin-right: 10px;
    }
    span {
        color: #fff;
        float: left;
    }
}
.w-460 {
    width: 460px;
}
.contact-box-h5 {
    width: 100%;
    height: 452px;
    margin: auto;
    box-sizing: border-box;
    .contact-box-left {
        width: 100%;
        float: left;
        padding: 10px;
        box-sizing: border-box;
        .contact-box-left-code {
            float: right;
            width: 100px;
            .contact-box-left-img {
                width: 100px;
                height: 100px;
            }
            .contact-box-left-title {
                font-size: 14px;
                color: #fff;
                width: 100px;
                text-align: center;
            }
        }
        
        .contact-box-left-info {
            float: left;
            width: calc(100% - 100px);
            font-size: 12px;
            color: #fff;
            .contact-box-left-info-title {

            }
            .split-line {
                height: 2px;
                
                width: 580px;
                background: #fff;
                margin: 10px 0;
            }
            .contact-box-left-info-long {
                width: 100%;
                line-height: 20px;
                float: left;
                .label {
                    float: left;
                    width: 60px;
                    display: inline-block;
                }
                .value {
                    float: left;
                    width: calc(100% - 60px);
                    display: inline-block;
                }
            }
            .contact-box-left-info-short {
                 width: 100%;
                line-height: 20px;
                float: left;
                .label {
                    float: left;
                    width: 60px;
                    display: inline-block;
                }
                .value {
                    float: left;
                    width: calc(100% - 60px);
                    display: inline-block;
                }
            }

        }
    }
    .contact-box-right {
        width: 100%;
        float: left;
        padding: 10px;
        box-sizing: border-box;
        .w-200 {
            width: 100%;        
        }
        .w-500 {
            width: 100%;
            height: 200px !important;
        }
        .yzm {
            height: 50px;
            line-height: 50px;
            display: inline-block;
            box-sizing: border-box;
            margin: 1px;
            background: #fff;
            text-align: center;
            font-size: 16px;
            width: 120px;
            color: #f56c6c;
        }
        .yzm2 {
            height: 50px;
            line-height: 50px;
            display: inline-block;
            box-sizing: border-box;
            margin: 1px;
            background: #fff;
            text-align: center;
            font-size: 14px;
            width: 120px;
            color: #f56c6c;
        }
        .custom-input {
            background: #e4e7edd4;
            border: none;
            padding: 4px 8px;
            box-sizing: border-box;
            color: #333;
            height: 32px;
            line-height: 32px;
            font-size: 12px;
            margin-bottom: 10px;
            float: left;
        }
        .submit-btn {
            height: 36px;
            line-height: 36px;
            display: inline-block;
            box-sizing: border-box;
            margin: 1px;
            background: #f00f0f;
            text-align: center;
            font-size: 14px;
            width: 100%;
            color: #fff;
        }
    }
}
.inside-box-h5 {
    width: 100%;
    height: 80px;
    text-align: center;
    box-sizing: border-box;
    position: absolute;
    top: 80px;
    img {
        width: 100px;
    }
}

.slide-one-left {
    position: absolute;
    width: 268px;
    height: 336px;
    top: 50%;
    margin-top: -168px;
    left: 12%;
}
.slide-one-right {
    position: absolute;
    width: 640px;
    height: 434px;
    top: 50%;
    margin-top: -217px;
    right: 0;
}

.slide-one-left2 {
    position: absolute;
    width: 82%;
    top: 0;
    margin-top: -60%;
    left: 0;
}
.slide-one-right2 {
    width: 70%;
    position: absolute;
    right: 0;
}
.jt {
    position: absolute;
    margin-left: 259px;
    top: 20%;
    width: 180px;
}
</style>
